import agent from "../../agent/agent";

const GET_GROUPS = "payflow/GET_GROUPS";
const GET_COUNTRIES = "payflow/GET_COUNTRIES";
const CHANGE_COUNTRY = "payflow/CHANGE_COUNTRY";

const initStage = {
	payItems: [],
	countries: [],
	countryGroups: [],

	selectCountry: null,

	isLoadingCountries: true,
	isLoadingCountryGroups: true,
};

export function getCountries () {
	return async function (dispatch) {
		const countries = await agent.get(`/api/payflow/countries`).then((res) => res?.data || []).catch(() => []);
		const selectCountry = countries?.[0];

		await dispatch({
			type: GET_COUNTRIES,
			countries: countries,
			selectCountry
		});
		await dispatch(getGroupsInCountry())
	}
}
export function getGroupsInCountry () {
	return async function (dispatch, getState) {
		const countrySlug = getState().payflow?.selectCountry?.slug;

		const groups = await agent.get(`/api/payflow/countries/${ countrySlug }/groups`).then((res) => res?.data || []).catch(() => []);
		const itemsPromises = groups.map(group => agent.get(`/api/payflow/countries/${countrySlug}/groups/${group.slug}`)
				.then((res) => {
					return (res?.data || []).map((item) => ({
						...item,
						groupSlug: group.slug
					}));
				})
				.catch(() => []));
		const itemsArrays = await Promise.all(itemsPromises);
		const items = itemsArrays.flat();

		dispatch({
			type: GET_GROUPS,
			value: groups,
			payItems: items,
		})
	}
}

export function changeCountry (country) {
	return async function (dispatch) {
		await dispatch({
			type: CHANGE_COUNTRY,
			country
		});
		await dispatch(getGroupsInCountry());
	}
}

export default function ProfileState (state = initStage, action = {}) {
	switch (action.type) {
		case GET_COUNTRIES: {
			return {
				...state,
				countries: action?.countries || [],
				selectCountry: action?.selectCountry || {},
				isLoadingCountries: false
			}
		}
		case GET_GROUPS: {
			return {
				...state,
				payItems: action?.payItems || [],
				countryGroups: action?.value || [],
				isLoadingCountryGroups: false
			}
		}

		case CHANGE_COUNTRY: {
			return {
				...state,
				selectCountry: action?.country || null,
				isLoadingCountryGroups: true
			}
		}

		default:
			return state;
	}
}
